import Pagination from '../Pagination'
import Sort from '../SortReq'

export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    // The backend filters on the orgIds / buIds SETS — the old single
    // orgId / branchId keys were silently ignored server-side.
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    creationTime: other.creationTime || null,
    firstName: other.firstName || null,
    lastName: other.lastName || null,
    login: other.login || null,
    phone: other.phone || null,
    email: other.email || null,
    alias: other.alias || null,
    code: other.code || null,
    company: other.company || null,
    website: other.website || null,
    group: other.group || null,
    skype: other.skype || null,
    alertEmail: other.alertEmail || null,
    active: other.active || null,
    hideFtd: other.hideFtd || null,
    affiliateCpas: other.affiliateCpas || null,
    //Search
    search: other.search || '',
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  }
}
